import { clarksonsBrokerHeading } from './clarksonsBrokerHeading';

export const clarksonsBrokerHeadingForFixtures = {
    ...clarksonsBrokerHeading,
    headerTooltip: 'Clarksons Internal Broker point contact for the fixture',
};
